import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const clearProviderOrdersLimitsSelectedYear = () => ({
  'type': ActionTypes.CLEAR_PROVIDER_ORDERS_LIMITS_SELECTED_YEAR,
});

export const addProviderOrderLimit = () => ({
  'type': ActionTypes.ADD_NEW_PROVIDER_ORDER_LIMIT,
});

export const getProviderOrdersHistoricLimits = () => apiActionCreator({
  'endpoint': '/orders/providers/amount-control',
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_REQUEST,
    ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_SUCCESS,
    [
      ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveProviderOrderLimit = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/providers/amount-control',
      'authenticated': true,
      'types': [
        ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_REQUEST,
        [
          () => {
            dispatch(getProviderOrdersHistoricLimits());
            return {
              'type': ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_SUCCESS,
            };
          },
          MessageActions.addMessageBoxInfo('Monto registrado satisfactoriamente'),
        ],
        [
          ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const getProviderOrderLimit = (filters) => apiActionCreator({
  'endpoint': '/orders/providers/amount-control',
  'authenticated': true,
  'types': [
    ActionTypes.GET_PROVIDER_ORDERS_LIMIT_REQUEST,
    {
      'type': ActionTypes.GET_PROVIDER_ORDERS_LIMIT_SUCCESS,
      'payload': filters.year,
    },
    [
      ActionTypes.GET_PROVIDER_ORDERS_LIMIT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': filters,
});
